module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "conversations-visitor-ui": "static-1.28445",
      "ably": "static-2.2",
      "data-fetching-client": "static-1.9514",
      "ably-hubspot-js": "static-2.4548",
      "atom": "static-1.4907",
      "conversations-async-data": "static-2.7500",
      "conversations-error-reporting": "static-1.8713",
      "conversations-internal-pub-sub": "static-1.15802",
      "conversations-internal-schema": "static-1.12547",
      "conversations-message-history": "static-1.12139",
      "conversations-test-sdk": "static-1.10335",
      "conversations-visitor-experience-components": "static-1.21808",
      "head-dlb": "static-1.4841",
      "hs-promise-utils": "static-1.5430",
      "hs-test-utils": "static-1.7843",
      "hubspot-dlb": "static-2.1806",
      "HubStyleTokens": "static-2.11278",
      "I18n": "static-7.1580",
      "immer": "static-1.33",
      "jasmine-immutable": "static-1.2854",
      "jasmine-runner": "static-1.6307",
      "quartz": "static-1.6780",
      "react-dlb": "static-1.73",
      "react-select-plus": "static-1.65",
      "react-transition-group": "static-2.61",
      "redux-thunk": "static-2.43",
      "sanitize": "static-1.4311",
      "StyleGuideUI": "static-3.484",
      "transmute": "static-2.85",
      "urlinator": "static-1.4368",
      "usage-tracker": "static-1.7172",
      "usage-tracker-core": "static-1.7022",
      "usage-tracker-public": "static-1.6983",
      "viral-links-lib": "static-1.6875",
      "visitor-ui-component-library": "static-1.5970",
      "webpack-env": "static-1.54",
      "autolinker": "static-3.11",
      "classnames": "static-2.10",
      "conversations-http": "static-1.4646",
      "conversations-prop-types": "static-1.7289",
      "conversations-visitor-message-history": "static-1.20545",
      "cssUtils": "static-1.744",
      "enviro": "static-4.405",
      "flux-actions": "static-1.311",
      "foundations-components": "static-1.7595",
      "hs-lodash": "static-4.45",
      "hub-http": "static-1.6054",
      "hubspot-url-utils": "static-1.3957",
      "immutable": "static-2.19",
      "metrics-js": "static-1.9436",
      "PatternValidationJS": "static-1.437",
      "PortalIdParser": "static-2.367",
      "raven": "static-3.5725",
      "react": "static-7.180",
      "react-aria": "static-1.62",
      "react-dom": "static-7.85",
      "react-redux": "static-7.67",
      "react-rhumb": "static-1.16488",
      "react-utils": "static-2.5210",
      "redux": "static-4.16",
      "redux-toolkit": "static-1.7",
      "reselect": "static-2.16",
      "sanitize-text": "static-1.7982",
      "signup-constants": "static-1.18498",
      "styled-components": "static-2.85",
      "usage-tracker-multi": "static-1.5586",
      "visitor-ui-component-library-icons": "static-1.5781",
      "hs-promise-rejection-tracking": "static-1.5387",
      "raven-hubspot": "static-1.6032",
      "hoist-non-react-statics": "static-3.9",
      "bend-plugin-trellis-migration": "static-1.3265",
      "moment": "static-3.26",
      "apollo-stack-hubspot": "static-3.82",
      "fast-json-stable-stringify": "static-1.4",
      "graphql": "static-1.78",
      "quartz-config": "static-1.558",
      "quartz-core": "static-1.5999",
      "react-immutable-proptypes": "static-2.8",
      "foundations-assets": "static-1.4676",
      "foundations-theming": "static-1.4247",
      "UIComponents": "static-3.8225",
      "customer-data-email": "static-1.17733",
      "cv-backend-services": "static-1.1514",
      "immutable-less": "static-1.4491",
      "conversations-skeleton-state": "static-1.7085",
      "crm-events-viz-core": "static-1.32595",
      "customer-data-objects": "static-1.7485",
      "icons": "static-2.626",
      "react-input-autosize": "static-2.17",
      "rpc-client-utils": "static-1.4474",
      "ui-images": "static-2.1106",
      "HeadJS": "static-2.718",
      "framer-motion": "static-1.68",
      "hs-test-utils-bend-plugin": "static-1.2954",
      "msw": "static-1.39",
      "testing-library": "static-1.148",
      "i18n-data": "static-1.217",
      "moment-timezone": "static-5.79",
      "jasmine": "static-4.4163",
      "signup-ui-url-generator": "static-2.7871",
      "HubStyle": "static-2.11586",
      "quartz-i18n": "static-1.455",
      "sassPrefix": "static-1.152",
      "bend-plugin-foundations-components": "static-1.3864",
      "floating-ui": "static-1.52",
      "foundations-theming-specialty": "static-1.1963",
      "hs-story-utils": "static-1.9263",
      "react-virtualized": "static-2.95",
      "tanstack-table": "static-1.51",
      "trellis-assets": "static-1.1312",
      "ui-fonts": "static-1.540",
      "csstype": "static-1.50",
      "quick-fetch": "static-1.3773",
      "history": "static-4.47",
      "usage-tracker-anonymous": "static-1.5589",
      "bender-build-tools": "static-1.2982",
      "dispatcher": "static-1.133",
      "general-store": "static-6.20",
      "hub-http-janus": "static-1.803",
      "hubspotter-http": "static-1.4514",
      "mobile-manifest-mixins": "static-1.491",
      "module-federation": "static-1.19",
      "quartz-auth": "static-1.455",
      "quartz-head": "static-1.445",
      "quartz-routing": "static-1.210",
      "quartz-test": "static-1.455",
      "quartz-tracking": "static-1.159",
      "usage-tracker-container": "static-1.7162",
      "bend-plugin-foundations-theming": "static-1.2730",
      "foundations-theming-base": "static-1.3232",
      "stylex": "static-1.28",
      "apollo-dlb": "static-3.80",
      "apollo-link-hub-http": "static-2.4488",
      "customer-data-ui-utilities": "static-1.9661",
      "FileManagerCore": "static-1.38505",
      "FileManagerLib": "static-1.38646",
      "hubspot-apollo-client": "static-1.4717",
      "react-immutable-render-mixin": "static-1.9",
      "salesImages": "static-1.521",
      "timezone-utils": "static-2.5081",
      "ui-gdpr-components": "static-1.10184",
      "ts-schema": "static-1.3941",
      "ai-components-ui-library": "static-1.8454",
      "avatar-components": "static-1.2327",
      "content-assistance-lib": "static-1.7503",
      "crm-component-utils": "static-1.38570",
      "crm-display-components": "static-1.24320",
      "crm-fe-perf": "static-1.22742",
      "crm-links": "static-1.6104",
      "crm-message-bus": "static-1.42476",
      "crm-search-service-types": "static-1.988",
      "crm-source-interpretation-lib": "static-1.5167",
      "customer-data-communicator": "static-1.45023",
      "customer-data-filters-ui": "static-1.39040",
      "customer-data-objects-ui-components": "static-1.12848",
      "customer-data-properties": "static-1.50874",
      "customer-data-rte": "static-1.32534",
      "draft-plugins": "static-2.21371",
      "file-manager-components": "static-1.23006",
      "framework-data-schema-resolvers": "static-1.6709",
      "frontend-preferences-client": "static-1.7761",
      "hubspot-prosemirror": "static-1.17704",
      "object-comments-thread-lib": "static-1.10174",
      "reference-resolvers-lite": "static-1.7923",
      "ui-addon-upgrades": "static-9.17707",
      "universal-associations-select": "static-1.10831",
      "universal-record-utils-lib": "static-1.357",
      "inbound-db-properties-service-client": "static-1.3710",
      "property-translator": "static-1.5245",
      "hub-http-shared-msw-handlers": "static-1.9562",
      "hubspotter-http-shared-msw-handlers": "static-1.9560",
      "react-router-dom": "static-5.26",
      "react-dnd-compat": "static-1.4457",
      "audio-components": "static-1.5667",
      "cropperjs": "static-1.10",
      "FileManagerImages": "static-1.36157",
      "foundations-components-legacy": "static-1.620",
      "immerable": "static-1.3991",
      "ui-universal-auth": "static-1.8753",
      "video-components": "static-1.12683",
      "video-data-lib": "static-1.34338",
      "video-embed": "static-1.35172",
      "hubspot-apollo-cache": "static-1.176",
      "chatspot-core": "static-1.20482",
      "chirp-fetch": "static-1.1719",
      "ContentUtils": "static-1.67731",
      "copilot-toolkit": "static-1.10627",
      "superstore": "static-1.4606",
      "ui-addon-video-player": "static-1.8533",
      "ui-coaching-tips": "static-1.28044",
      "card-properties-lib": "static-1.43632",
      "commerce-subscription-lib": "static-1.36566",
      "crm-actions": "static-1.6142",
      "crm-cards-data": "static-1.1295",
      "crm-cards-sdk": "static-1.43033",
      "customer-data-properties-shared-msw-handlers": "static-1.8889",
      "customer-data-property-utils": "static-1.7916",
      "customer-data-tracking": "static-1.6719",
      "inbound-db-meta-service-client": "static-1.3456",
      "framework-data-table": "static-2.11503",
      "location-customization-utils-lib": "static-1.8679",
      "calling-error-reporting": "static-1.31138",
      "calling-internal-common": "static-1.31132",
      "calling-usage-tracker": "static-1.6378",
      "crm_data": "static-4.91365",
      "customer-data-content": "static-1.26937",
      "draft-content-plugins": "static-1.27801",
      "draft-convert": "static-2.68",
      "draft-extend": "static-3.71",
      "draft-js": "static-5.73",
      "draft-signature-plugin": "static-1.23603",
      "EmailSignatureEditor": "static-1.23979",
      "hubspot-prosemirror-plugins": "static-1.17696",
      "integration-settings-components": "static-1.14913",
      "integrations-lib": "static-1.15551",
      "integrations-tracking-lib": "static-1.5425",
      "native-integrations-shared-strings": "static-1.7625",
      "nav-meta": "static-1.29036",
      "onboarding-scopes": "static-1.6300",
      "outreach-assistant-email-generation": "static-1.5849",
      "prosemirror": "static-1.13",
      "quotes-client-types": "static-1.37415",
      "react-colorpicker": "static-2.10048",
      "reference-resolvers": "static-1.7999",
      "rich-text-lib": "static-1.19534",
      "sales-email-signature-service-client": "static-1.3680",
      "sequences-lib": "static-1.7745",
      "ui-addon-i18n": "static-1.10981",
      "ui-addon-iframeable": "static-1.8884",
      "ui-business-units-lib": "static-1.8868",
      "ui-shepherd-react": "static-3.9983",
      "user-context": "static-1.4936",
      "whatsapp-sending-lib": "static-1.5038",
      "customer-data-filters-ui-msw-helpers": "static-1.21475",
      "customer-data-reference-ui-components": "static-1.12984",
      "FormUrlGenerator": "static-2.4558",
      "framework-builder-read-service-client": "static-1.3869",
      "framework-data-schema-quick-fetch": "static-1.6614",
      "multi-account-reference-resolvers": "static-1.810",
      "onboarding-tours": "static-1.16315",
      "reporting-datasets-permissions-lib": "static-1.13168",
      "SharedI18nStrings": "static-1.180",
      "ui-addon-teams": "static-1.21288",
      "calling-global-api": "static-1.63803",
      "calling-lifecycle-internal": "static-1.65185",
      "calling-lifecycle-messages": "static-1.57479",
      "commerce-products-lib": "static-1.8958",
      "conditional-properties-service-client": "static-1.3659",
      "external-options-client-types": "static-1.4020",
      "google-libphonenumber": "static-1.34",
      "hs-entities": "static-1.517",
      "inbounddb-objects-service-types": "static-1.4084",
      "meetings-icalendar-utils-lib": "static-1.469",
      "multi-currency-client-types": "static-1.3552",
      "object-builder-ui-client": "static-1.48124",
      "pipeline-validation-client-types": "static-1.3825",
      "property-value-citations": "static-1.1488",
      "pulse": "static-1.353",
      "smart-property-lib": "static-1.6084",
      "tiered-pricing": "static-1.881",
      "ui-addon-form-validation": "static-1.10830",
      "video-components-external": "static-1.10680",
      "batch-promise": "static-1.1388",
      "crm-pipelines-api-client-types": "static-1.4001",
      "persist-promise": "static-1.3545",
      "emoji-mart": "static-3.4",
      "growth-payments-core": "static-1.24833",
      "knowledge-content-types": "static-1.8404",
      "payment-link-components": "static-1.23040",
      "ui-addon-emoji-picker": "static-1.9724",
      "call-summary": "static-1.38494",
      "reference-resolvers-lite-shared-msw-handlers": "static-1.9708",
      "laboratory-lib": "static-3.6996",
      "merchandise-lib": "static-1.260",
      "purchase-motions-components": "static-1.5525",
      "crm-object-search-query-utilities": "static-1.9156",
      "react-dnd": "static-5.6",
      "react-dnd-html5-backend": "static-5.6",
      "unified-auth-core-lib": "static-1.548",
      "content-icons-ui": "static-1.2167",
      "social-insights-client-types": "static-1.21467",
      "outpost": "static-1.4038",
      "markdown-it": "static-1.6",
      "cms-field-types": "static-1.4644",
      "underscore": "static-1.8",
      "magpie-lib": "static-1.5431",
      "magpie-types": "static-1.4891",
      "simple-logging-lib": "static-1.2887",
      "growth-onboarding-feedback-components": "static-1.6418",
      "customer-data-sidebar": "static-2.45516",
      "enrichment-properties-lib": "static-1.15202",
      "commerce-billing-lib": "static-1.18597",
      "commerce-shared-components-lib": "static-1.18045",
      "commerce-tools-ui-lib": "static-1.9888",
      "customer-data-associations": "static-1.7169",
      "deal-intel-decorators": "static-1.1388",
      "reporting-data": "static-1.66673",
      "tanstack-virtual": "static-1.26",
      "ui-addon-draggable": "static-3.4603",
      "crm-record-cards-service-types": "static-1.3479",
      "self-service-api": "static-1.10077",
      "crm_universal": "static-1.21722",
      "SalesContentIndexUI": "static-3.8954",
      "content-embed-lib": "static-1.7177",
      "data-model-builder-lib": "static-1.11759",
      "remote-ui": "static-1.61",
      "ui-components-test-utils": "static-1.5416",
      "ui-extensions-remote-renderer": "static-1.16449",
      "universal-page-editor-lib": "static-1.2835",
      "integrations-error-boundary-lib": "static-1.12966",
      "redux-observable": "static-1.11",
      "ReduxMessenger": "static-2.10210",
      "rxjs": "static-5.10",
      "messaging-types-lib": "static-1.45507",
      "data-token-picker": "static-1.16106",
      "sequences-client-types-lib": "static-1.7602",
      "foundations-components-test-utils": "static-1.5078",
      "navigation-messaging": "static-1.6726",
      "getting-started-shared-tasks": "static-1.17987",
      "getting-started-shared-tasks-store": "static-1.17105",
      "onboarding-tours-utils": "static-1.381",
      "messaging-usage-based-billing-components-lib": "static-1.632",
      "whatsapp-management-lib": "static-1.8197",
      "growth-data-modal": "static-1.5195",
      "growth-onboarding-confetti": "static-1.2909",
      "growth-onboarding-next-action-utils": "static-1.1392",
      "navigation-components": "static-1.17399",
      "onboarding-tours-client": "static-1.4529",
      "ui-shepherd-tracker": "static-1.7364",
      "shared-worker-versioning": "static-1.10876",
      "voice-sms-access-library": "static-1.355",
      "commerce-permissions": "static-1.598",
      "products-iframe-lib": "static-1.7430",
      "products-ui-components-shared-msw-handlers": "static-1.9944",
      "directed-graph": "static-1.776",
      "event-emitter": "static-1.784",
      "breeze-intelligence-kit": "static-1.5377",
      "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9645",
      "fsm": "static-1.3567",
      "policy-lib": "static-1.6614",
      "react-tinymce": "static-1.54721",
      "tinymce": "static-5.11",
      "tinymce-config": "static-2.53847",
      "tinymce-plugins": "static-1.56961",
      "tinymce-themes": "static-1.55817",
      "content-media-composition-data-lib": "static-1.11586",
      "content-media-compositions": "static-2.15593",
      "idb-keyval": "static-1.40",
      "media-bridge-lib": "static-1.18628",
      "ui-addon-opt": "static-4.8222",
      "commerce-tours-lib": "static-1.5771",
      "growth-onboarding-reliability": "static-1.4923",
      "sales-checkout-service-client": "static-1.3504",
      "ai-addon-copilot-preview": "static-1.7666",
      "calling-cross-tab-library": "static-1.19103",
      "calling-lifecycle-usage-tracker": "static-1.8228",
      "wootric-nps": "static-1.6821",
      "growth-monetization-service-types": "static-1.4336",
      "nav-client-types": "static-1.2194",
      "purchase-motions-api": "static-1.5528",
      "trials-service-types": "static-1.3737",
      "reactive-lib": "static-1.562",
      "card-payment-highlight-lib": "static-1.36616",
      "card-subscription-highlight-lib": "static-1.38989",
      "commerce-contract-lib": "static-1.11334",
      "invoices-highlight-card-lib": "static-1.54149",
      "orders-highlight-card-lib": "static-1.20959",
      "products-highlight-card-lib": "static-1.17242",
      "project-storage": "static-1.4570",
      "quotes-highlight-card-lib": "static-1.71326",
      "usage-based-billing-components-lib": "static-1.8109",
      "usage-tracker-session-replay": "static-1.4858",
      "utility-belt": "static-1.2377",
      "payments-enrollment-embed-lib": "static-1.22126",
      "growth-onboarding-empty-states": "static-1.5423",
      "InboxConnectUtils": "static-4.14319",
      "payments-post-enroll-local-storage-lib": "static-1.4951",
      "qrcode-generator": "static-1.65",
      "deal-intel-utils": "static-1.1392",
      "storybook-react": "static-1.29",
      "reporting-client-types": "static-1.2387",
      "react-flip-move": "static-1.66",
      "FireAlarmUi": "static-1.4368",
      "sales-templates-service-types-lib": "static-1.4028",
      "ui-asset-management-lib": "static-1.10756",
      "association-settings-lib": "static-1.9767",
      "collaboration-sidebar": "static-1.57230",
      "conditional-property-settings-modal": "static-1.12033",
      "data-model-commons-lib": "static-1.12046",
      "feedback-loader": "static-1.28938",
      "final-form": "static-1.66",
      "html-to-image": "static-1.50",
      "object-definition-builder-lib": "static-1.6906",
      "property-management-iframe": "static-1.12486",
      "property-usages-lib": "static-1.5234",
      "reactflow": "static-1.60",
      "simple-data-table": "static-1.2285",
      "used-in-list-lib": "static-1.6761",
      "visual-association": "static-1.5689",
      "highcharts": "static-8.100",
      "reporting-visualizations": "static-1.58749",
      "ui-extensibility-client-types": "static-1.3781",
      "automation-platform-service-types": "static-1.2522",
      "ContentData": "static-1.67806",
      "email-portal-health-service-types": "static-1.813",
      "marketing-email-service-types": "static-1.1790",
      "messaging-shared-utils-lib": "static-1.81",
      "messaging-user-info-utils-lib": "static-1.251",
      "content-whatsapp-service-types": "static-1.272",
      "marketing-platform-lib": "static-1.6679",
      "short-messages-app-service-client": "static-1.3849",
      "ui-tool-access": "static-1.9981",
      "growth-onboarding-next-action-components": "static-1.1420",
      "user-context-client": "static-1.4477",
      "calling-orchestration-schema": "static-1.35132",
      "sales-views-client-types": "static-1.4123",
      "trellis-story-utils": "static-1.4357",
      "hub-http-contrib": "static-1.2880",
      "interframe": "static-3.4617",
      "tinymce-data": "static-1.39932",
      "ui-addon-sales-email": "static-1.5051",
      "codemirror": "static-5.91",
      "layout-dnd-components": "static-1.12106",
      "layout-dnd-utils": "static-1.11081",
      "react-codemirror": "static-1.10463",
      "ui-brand-identity-lib": "static-1.14136",
      "NamespacedHubStyle": "static-2.8932",
      "hls.js": "static-1.35",
      "js-cookie": "static-1.18",
      "ai-rendering-library": "static-1.9417",
      "ai-settings-ui-library": "static-1.7558",
      "copilot-plugins": "static-1.10600",
      "eligibility-engine-service-types": "static-1.3018",
      "products-ui-components": "static-1.39477",
      "quotes-ui-lib": "static-1.80046",
      "zustand": "static-1.51",
      "accounting-integrations-ui-components": "static-1.6784",
      "invoices-ui-lib": "static-1.54165",
      "commerce-products-api": "static-1.2007",
      "SafeStorage": "static-1.4240",
      "invoices-iframe-lib": "static-1.56223",
      "quotes-modal-lib": "static-1.102003",
      "platform-infra-nav-components": "static-1.7527",
      "reporting-ui-components": "static-2.63944",
      "subscription-experience-data-types": "static-1.14627",
      "amplitude-session-replay-browser": "static-1.56",
      "marketplace-ui-apps-core": "static-1.17585",
      "stripe-embedded-components": "static-1.7198",
      "ui-addon-react-router-dom": "static-1.9382",
      "association-translator": "static-1.3024",
      "crm-settings-header-lib": "static-1.8154",
      "settings-ui-nav": "static-2.10020",
      "chatspot-widget-iframe": "static-1.20474",
      "collaboration-sidebar-common": "static-1.2027",
      "crm-properties-common-lib": "static-1.5709",
      "ui-addon-draggable-compat": "static-2.4091",
      "property-management-common": "static-1.4773",
      "d3": "static-1.7",
      "advanced-menus-core": "static-1.14872",
      "advanced-menus-lib": "static-1.11842",
      "ExportDialog": "static-6.10224",
      "ui-memberships-settings-lib": "static-1.33550",
      "diff-match-patch": "static-1.7",
      "layout-data-lib": "static-1.9406",
      "browser-eslint": "static-2.57",
      "embedded-academy-lib": "static-1.13682",
      "highlight.js": "static-1.75",
      "reporting-action-components": "static-1.40750",
      "reporting-snowflake": "static-1.55291",
      "commerce-tax-lib": "static-1.353",
      "property-description-translator": "static-1.3692",
      "commerce-analytics-service-client": "static-1.3492",
      "totals-ui-components": "static-1.23089",
      "reporting-plugins": "static-1.10022",
      "reporting-reports": "static-1.66351",
      "edison-service-client-types": "static-1.229",
      "developer-experience-shared-components": "static-1.10330",
      "marketplace-ui-client-types": "static-1.16459",
      "marketplace-ui-common": "static-1.19052",
      "ui-addon-integrations-directory-panel": "static-2.7829",
      "stripe-connect-js": "static-1.65",
      "seamless-immutable": "static-7.6",
      "simple-menus-core": "static-1.14871",
      "simple-menus-lib": "static-1.16388",
      "academy-common-lib": "static-1.13142",
      "dashboard-lib": "static-1.80777",
      "share-with-third-party-component-lib": "static-1.8530",
      "commerce-totals-service-types": "static-1.3676",
      "campaign-roi-lib": "static-1.8396",
      "apps-service-types": "static-1.3714",
      "oauth-service-types": "static-1.4084",
      "react-window": "static-1.13",
      "academy-service-client": "static-1.3518",
      "redux-actions": "static-3.7"
    },
    "depPathPrefixes": {
      "conversations-visitor-ui": "/conversations-visitor-ui/static-1.28445",
      "ably": "/ably/static-2.2",
      "data-fetching-client": "/data-fetching-client/static-1.9514",
      "ably-hubspot-js": "/ably-hubspot-js/static-2.4548",
      "atom": "/atom/static-1.4907",
      "conversations-async-data": "/conversations-async-data/static-2.7500",
      "conversations-error-reporting": "/conversations-error-reporting/static-1.8713",
      "conversations-internal-pub-sub": "/conversations-internal-pub-sub/static-1.15802",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.12547",
      "conversations-message-history": "/conversations-message-history/static-1.12139",
      "conversations-test-sdk": "/conversations-test-sdk/static-1.10335",
      "conversations-visitor-experience-components": "/conversations-visitor-experience-components/static-1.21808",
      "head-dlb": "/head-dlb/static-1.4841",
      "hs-promise-utils": "/hs-promise-utils/static-1.5430",
      "hs-test-utils": "/hs-test-utils/static-1.7843",
      "hubspot-dlb": "/hubspot-dlb/static-2.1806",
      "HubStyleTokens": "/HubStyleTokens/static-2.11278",
      "I18n": "/I18n/static-7.1580",
      "immer": "/immer/static-1.33",
      "jasmine-immutable": "/jasmine-immutable/static-1.2854",
      "jasmine-runner": "/jasmine-runner/static-1.6307",
      "quartz": "/quartz/static-1.6780",
      "react-dlb": "/react-dlb/static-1.73",
      "react-select-plus": "/react-select-plus/static-1.65",
      "react-transition-group": "/react-transition-group/static-2.61",
      "redux-thunk": "/redux-thunk/static-2.43",
      "sanitize": "/sanitize/static-1.4311",
      "StyleGuideUI": "/StyleGuideUI/static-3.484",
      "transmute": "/transmute/static-2.85",
      "urlinator": "/urlinator/static-1.4368",
      "usage-tracker": "/usage-tracker/static-1.7172",
      "usage-tracker-core": "/usage-tracker-core/static-1.7022",
      "usage-tracker-public": "/usage-tracker-public/static-1.6983",
      "viral-links-lib": "/viral-links-lib/static-1.6875",
      "visitor-ui-component-library": "/visitor-ui-component-library/static-1.5970",
      "webpack-env": "/webpack-env/static-1.54",
      "autolinker": "/autolinker/static-3.11",
      "classnames": "/classnames/static-2.10",
      "conversations-http": "/conversations-http/static-1.4646",
      "conversations-prop-types": "/conversations-prop-types/static-1.7289",
      "conversations-visitor-message-history": "/conversations-visitor-message-history/static-1.20545",
      "cssUtils": "/cssUtils/static-1.744",
      "enviro": "/enviro/static-4.405",
      "flux-actions": "/flux-actions/static-1.311",
      "foundations-components": "/foundations-components/static-1.7595",
      "hs-lodash": "/hs-lodash/static-4.45",
      "hub-http": "/hub-http/static-1.6054",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.3957",
      "immutable": "/immutable/static-2.19",
      "metrics-js": "/metrics-js/static-1.9436",
      "PatternValidationJS": "/PatternValidationJS/static-1.437",
      "PortalIdParser": "/PortalIdParser/static-2.367",
      "raven": "/raven/static-3.5725",
      "react": "/react/static-7.180",
      "react-aria": "/react-aria/static-1.62",
      "react-dom": "/react-dom/static-7.85",
      "react-redux": "/react-redux/static-7.67",
      "react-rhumb": "/react-rhumb/static-1.16488",
      "react-utils": "/react-utils/static-2.5210",
      "redux": "/redux/static-4.16",
      "redux-toolkit": "/redux-toolkit/static-1.7",
      "reselect": "/reselect/static-2.16",
      "sanitize-text": "/sanitize-text/static-1.7982",
      "signup-constants": "/signup-constants/static-1.18498",
      "styled-components": "/styled-components/static-2.85",
      "usage-tracker-multi": "/usage-tracker-multi/static-1.5586",
      "visitor-ui-component-library-icons": "/visitor-ui-component-library-icons/static-1.5781",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5387",
      "raven-hubspot": "/raven-hubspot/static-1.6032",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3265",
      "moment": "/moment/static-3.26",
      "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.82",
      "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
      "graphql": "/graphql/static-1.78",
      "quartz-config": "/quartz-config/static-1.558",
      "quartz-core": "/quartz-core/static-1.5999",
      "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
      "foundations-assets": "/foundations-assets/static-1.4676",
      "foundations-theming": "/foundations-theming/static-1.4247",
      "UIComponents": "/UIComponents/static-3.8225",
      "customer-data-email": "/customer-data-email/static-1.17733",
      "cv-backend-services": "/cv-backend-services/static-1.1514",
      "immutable-less": "/immutable-less/static-1.4491",
      "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7085",
      "crm-events-viz-core": "/crm-events-viz-core/static-1.32595",
      "customer-data-objects": "/customer-data-objects/static-1.7485",
      "icons": "/icons/static-2.626",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "rpc-client-utils": "/rpc-client-utils/static-1.4474",
      "ui-images": "/ui-images/static-2.1106",
      "HeadJS": "/HeadJS/static-2.718",
      "framer-motion": "/framer-motion/static-1.68",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2954",
      "msw": "/msw/static-1.39",
      "testing-library": "/testing-library/static-1.148",
      "i18n-data": "/i18n-data/static-1.217",
      "moment-timezone": "/moment-timezone/static-5.79",
      "jasmine": "/jasmine/static-4.4163",
      "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7871",
      "HubStyle": "/HubStyle/static-2.11586",
      "quartz-i18n": "/quartz-i18n/static-1.455",
      "sassPrefix": "/sassPrefix/static-1.152",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3864",
      "floating-ui": "/floating-ui/static-1.52",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1963",
      "hs-story-utils": "/hs-story-utils/static-1.9263",
      "react-virtualized": "/react-virtualized/static-2.95",
      "tanstack-table": "/tanstack-table/static-1.51",
      "trellis-assets": "/trellis-assets/static-1.1312",
      "ui-fonts": "/ui-fonts/static-1.540",
      "csstype": "/csstype/static-1.50",
      "quick-fetch": "/quick-fetch/static-1.3773",
      "history": "/history/static-4.47",
      "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5589",
      "bender-build-tools": "/bender-build-tools/static-1.2982",
      "dispatcher": "/dispatcher/static-1.133",
      "general-store": "/general-store/static-6.20",
      "hub-http-janus": "/hub-http-janus/static-1.803",
      "hubspotter-http": "/hubspotter-http/static-1.4514",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.491",
      "module-federation": "/module-federation/static-1.19",
      "quartz-auth": "/quartz-auth/static-1.455",
      "quartz-head": "/quartz-head/static-1.445",
      "quartz-routing": "/quartz-routing/static-1.210",
      "quartz-test": "/quartz-test/static-1.455",
      "quartz-tracking": "/quartz-tracking/static-1.159",
      "usage-tracker-container": "/usage-tracker-container/static-1.7162",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2730",
      "foundations-theming-base": "/foundations-theming-base/static-1.3232",
      "stylex": "/stylex/static-1.28",
      "apollo-dlb": "/apollo-dlb/static-3.80",
      "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4488",
      "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9661",
      "FileManagerCore": "/FileManagerCore/static-1.38505",
      "FileManagerLib": "/FileManagerLib/static-1.38646",
      "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4717",
      "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
      "salesImages": "/salesImages/static-1.521",
      "timezone-utils": "/timezone-utils/static-2.5081",
      "ui-gdpr-components": "/ui-gdpr-components/static-1.10184",
      "ts-schema": "/ts-schema/static-1.3941",
      "ai-components-ui-library": "/ai-components-ui-library/static-1.8454",
      "avatar-components": "/avatar-components/static-1.2327",
      "content-assistance-lib": "/content-assistance-lib/static-1.7503",
      "crm-component-utils": "/crm-component-utils/static-1.38570",
      "crm-display-components": "/crm-display-components/static-1.24320",
      "crm-fe-perf": "/crm-fe-perf/static-1.22742",
      "crm-links": "/crm-links/static-1.6104",
      "crm-message-bus": "/crm-message-bus/static-1.42476",
      "crm-search-service-types": "/crm-search-service-types/static-1.988",
      "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5167",
      "customer-data-communicator": "/customer-data-communicator/static-1.45023",
      "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39040",
      "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12848",
      "customer-data-properties": "/customer-data-properties/static-1.50874",
      "customer-data-rte": "/customer-data-rte/static-1.32534",
      "draft-plugins": "/draft-plugins/static-2.21371",
      "file-manager-components": "/file-manager-components/static-1.23006",
      "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6709",
      "frontend-preferences-client": "/frontend-preferences-client/static-1.7761",
      "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17704",
      "object-comments-thread-lib": "/object-comments-thread-lib/static-1.10174",
      "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7923",
      "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17707",
      "universal-associations-select": "/universal-associations-select/static-1.10831",
      "universal-record-utils-lib": "/universal-record-utils-lib/static-1.357",
      "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3710",
      "property-translator": "/property-translator/static-1.5245",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9562",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9560",
      "react-router-dom": "/react-router-dom/static-5.26",
      "react-dnd-compat": "/react-dnd-compat/static-1.4457",
      "audio-components": "/audio-components/static-1.5667",
      "cropperjs": "/cropperjs/static-1.10",
      "FileManagerImages": "/FileManagerImages/static-1.36157",
      "foundations-components-legacy": "/foundations-components-legacy/static-1.620",
      "immerable": "/immerable/static-1.3991",
      "ui-universal-auth": "/ui-universal-auth/static-1.8753",
      "video-components": "/video-components/static-1.12683",
      "video-data-lib": "/video-data-lib/static-1.34338",
      "video-embed": "/video-embed/static-1.35172",
      "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.176",
      "chatspot-core": "/chatspot-core/static-1.20482",
      "chirp-fetch": "/chirp-fetch/static-1.1719",
      "ContentUtils": "/ContentUtils/static-1.67731",
      "copilot-toolkit": "/copilot-toolkit/static-1.10627",
      "superstore": "/superstore/static-1.4606",
      "ui-addon-video-player": "/ui-addon-video-player/static-1.8533",
      "ui-coaching-tips": "/ui-coaching-tips/static-1.28044",
      "card-properties-lib": "/card-properties-lib/static-1.43632",
      "commerce-subscription-lib": "/commerce-subscription-lib/static-1.36566",
      "crm-actions": "/crm-actions/static-1.6142",
      "crm-cards-data": "/crm-cards-data/static-1.1295",
      "crm-cards-sdk": "/crm-cards-sdk/static-1.43033",
      "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.8889",
      "customer-data-property-utils": "/customer-data-property-utils/static-1.7916",
      "customer-data-tracking": "/customer-data-tracking/static-1.6719",
      "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3456",
      "framework-data-table": "/framework-data-table/static-2.11503",
      "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8679",
      "calling-error-reporting": "/calling-error-reporting/static-1.31138",
      "calling-internal-common": "/calling-internal-common/static-1.31132",
      "calling-usage-tracker": "/calling-usage-tracker/static-1.6378",
      "crm_data": "/crm_data/static-4.91365",
      "customer-data-content": "/customer-data-content/static-1.26937",
      "draft-content-plugins": "/draft-content-plugins/static-1.27801",
      "draft-convert": "/draft-convert/static-2.68",
      "draft-extend": "/draft-extend/static-3.71",
      "draft-js": "/draft-js/static-5.73",
      "draft-signature-plugin": "/draft-signature-plugin/static-1.23603",
      "EmailSignatureEditor": "/EmailSignatureEditor/static-1.23979",
      "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17696",
      "integration-settings-components": "/integration-settings-components/static-1.14913",
      "integrations-lib": "/integrations-lib/static-1.15551",
      "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5425",
      "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7625",
      "nav-meta": "/nav-meta/static-1.29036",
      "onboarding-scopes": "/onboarding-scopes/static-1.6300",
      "outreach-assistant-email-generation": "/outreach-assistant-email-generation/static-1.5849",
      "prosemirror": "/prosemirror/static-1.13",
      "quotes-client-types": "/quotes-client-types/static-1.37415",
      "react-colorpicker": "/react-colorpicker/static-2.10048",
      "reference-resolvers": "/reference-resolvers/static-1.7999",
      "rich-text-lib": "/rich-text-lib/static-1.19534",
      "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3680",
      "sequences-lib": "/sequences-lib/static-1.7745",
      "ui-addon-i18n": "/ui-addon-i18n/static-1.10981",
      "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8884",
      "ui-business-units-lib": "/ui-business-units-lib/static-1.8868",
      "ui-shepherd-react": "/ui-shepherd-react/static-3.9983",
      "user-context": "/user-context/static-1.4936",
      "whatsapp-sending-lib": "/whatsapp-sending-lib/static-1.5038",
      "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21475",
      "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.12984",
      "FormUrlGenerator": "/FormUrlGenerator/static-2.4558",
      "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3869",
      "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6614",
      "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.810",
      "onboarding-tours": "/onboarding-tours/static-1.16315",
      "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13168",
      "SharedI18nStrings": "/SharedI18nStrings/static-1.180",
      "ui-addon-teams": "/ui-addon-teams/static-1.21288",
      "calling-global-api": "/calling-global-api/static-1.63803",
      "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65185",
      "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57479",
      "commerce-products-lib": "/commerce-products-lib/static-1.8958",
      "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3659",
      "external-options-client-types": "/external-options-client-types/static-1.4020",
      "google-libphonenumber": "/google-libphonenumber/static-1.34",
      "hs-entities": "/hs-entities/static-1.517",
      "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4084",
      "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.469",
      "multi-currency-client-types": "/multi-currency-client-types/static-1.3552",
      "object-builder-ui-client": "/object-builder-ui-client/static-1.48124",
      "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3825",
      "property-value-citations": "/property-value-citations/static-1.1488",
      "pulse": "/pulse/static-1.353",
      "smart-property-lib": "/smart-property-lib/static-1.6084",
      "tiered-pricing": "/tiered-pricing/static-1.881",
      "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10830",
      "video-components-external": "/video-components-external/static-1.10680",
      "batch-promise": "/batch-promise/static-1.1388",
      "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4001",
      "persist-promise": "/persist-promise/static-1.3545",
      "emoji-mart": "/emoji-mart/static-3.4",
      "growth-payments-core": "/growth-payments-core/static-1.24833",
      "knowledge-content-types": "/knowledge-content-types/static-1.8404",
      "payment-link-components": "/payment-link-components/static-1.23040",
      "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9724",
      "call-summary": "/call-summary/static-1.38494",
      "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9708",
      "laboratory-lib": "/laboratory-lib/static-3.6996",
      "merchandise-lib": "/merchandise-lib/static-1.260",
      "purchase-motions-components": "/purchase-motions-components/static-1.5525",
      "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.9156",
      "react-dnd": "/react-dnd/static-5.6",
      "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
      "unified-auth-core-lib": "/unified-auth-core-lib/static-1.548",
      "content-icons-ui": "/content-icons-ui/static-1.2167",
      "social-insights-client-types": "/social-insights-client-types/static-1.21467",
      "outpost": "/outpost/static-1.4038",
      "markdown-it": "/markdown-it/static-1.6",
      "cms-field-types": "/cms-field-types/static-1.4644",
      "underscore": "/underscore/static-1.8",
      "magpie-lib": "/magpie-lib/static-1.5431",
      "magpie-types": "/magpie-types/static-1.4891",
      "simple-logging-lib": "/simple-logging-lib/static-1.2887",
      "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6418",
      "customer-data-sidebar": "/customer-data-sidebar/static-2.45516",
      "enrichment-properties-lib": "/enrichment-properties-lib/static-1.15202",
      "commerce-billing-lib": "/commerce-billing-lib/static-1.18597",
      "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.18045",
      "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.9888",
      "customer-data-associations": "/customer-data-associations/static-1.7169",
      "deal-intel-decorators": "/deal-intel-decorators/static-1.1388",
      "reporting-data": "/reporting-data/static-1.66673",
      "tanstack-virtual": "/tanstack-virtual/static-1.26",
      "ui-addon-draggable": "/ui-addon-draggable/static-3.4603",
      "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3479",
      "self-service-api": "/self-service-api/static-1.10077",
      "crm_universal": "/crm_universal/static-1.21722",
      "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8954",
      "content-embed-lib": "/content-embed-lib/static-1.7177",
      "data-model-builder-lib": "/data-model-builder-lib/static-1.11759",
      "remote-ui": "/remote-ui/static-1.61",
      "ui-components-test-utils": "/ui-components-test-utils/static-1.5416",
      "ui-extensions-remote-renderer": "/ui-extensions-remote-renderer/static-1.16449",
      "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2835",
      "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12966",
      "redux-observable": "/redux-observable/static-1.11",
      "ReduxMessenger": "/ReduxMessenger/static-2.10210",
      "rxjs": "/rxjs/static-5.10",
      "messaging-types-lib": "/messaging-types-lib/static-1.45507",
      "data-token-picker": "/data-token-picker/static-1.16106",
      "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7602",
      "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5078",
      "navigation-messaging": "/navigation-messaging/static-1.6726",
      "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.17987",
      "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17105",
      "onboarding-tours-utils": "/onboarding-tours-utils/static-1.381",
      "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.632",
      "whatsapp-management-lib": "/whatsapp-management-lib/static-1.8197",
      "growth-data-modal": "/growth-data-modal/static-1.5195",
      "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2909",
      "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1392",
      "navigation-components": "/navigation-components/static-1.17399",
      "onboarding-tours-client": "/onboarding-tours-client/static-1.4529",
      "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7364",
      "shared-worker-versioning": "/shared-worker-versioning/static-1.10876",
      "voice-sms-access-library": "/voice-sms-access-library/static-1.355",
      "commerce-permissions": "/commerce-permissions/static-1.598",
      "products-iframe-lib": "/products-iframe-lib/static-1.7430",
      "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9944",
      "directed-graph": "/directed-graph/static-1.776",
      "event-emitter": "/event-emitter/static-1.784",
      "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5377",
      "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9645",
      "fsm": "/fsm/static-1.3567",
      "policy-lib": "/policy-lib/static-1.6614",
      "react-tinymce": "/react-tinymce/static-1.54721",
      "tinymce": "/tinymce/static-5.11",
      "tinymce-config": "/tinymce-config/static-2.53847",
      "tinymce-plugins": "/tinymce-plugins/static-1.56961",
      "tinymce-themes": "/tinymce-themes/static-1.55817",
      "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11586",
      "content-media-compositions": "/content-media-compositions/static-2.15593",
      "idb-keyval": "/idb-keyval/static-1.40",
      "media-bridge-lib": "/media-bridge-lib/static-1.18628",
      "ui-addon-opt": "/ui-addon-opt/static-4.8222",
      "commerce-tours-lib": "/commerce-tours-lib/static-1.5771",
      "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4923",
      "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3504",
      "ai-addon-copilot-preview": "/ai-addon-copilot-preview/static-1.7666",
      "calling-cross-tab-library": "/calling-cross-tab-library/static-1.19103",
      "calling-lifecycle-usage-tracker": "/calling-lifecycle-usage-tracker/static-1.8228",
      "wootric-nps": "/wootric-nps/static-1.6821",
      "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4336",
      "nav-client-types": "/nav-client-types/static-1.2194",
      "purchase-motions-api": "/purchase-motions-api/static-1.5528",
      "trials-service-types": "/trials-service-types/static-1.3737",
      "reactive-lib": "/reactive-lib/static-1.562",
      "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.36616",
      "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.38989",
      "commerce-contract-lib": "/commerce-contract-lib/static-1.11334",
      "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.54149",
      "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.20959",
      "products-highlight-card-lib": "/products-highlight-card-lib/static-1.17242",
      "project-storage": "/project-storage/static-1.4570",
      "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.71326",
      "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.8109",
      "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4858",
      "utility-belt": "/utility-belt/static-1.2377",
      "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.22126",
      "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5423",
      "InboxConnectUtils": "/InboxConnectUtils/static-4.14319",
      "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.4951",
      "qrcode-generator": "/qrcode-generator/static-1.65",
      "deal-intel-utils": "/deal-intel-utils/static-1.1392",
      "storybook-react": "/storybook-react/static-1.29",
      "reporting-client-types": "/reporting-client-types/static-1.2387",
      "react-flip-move": "/react-flip-move/static-1.66",
      "FireAlarmUi": "/FireAlarmUi/static-1.4368",
      "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4028",
      "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10756",
      "association-settings-lib": "/association-settings-lib/static-1.9767",
      "collaboration-sidebar": "/collaboration-sidebar/static-1.57230",
      "conditional-property-settings-modal": "/conditional-property-settings-modal/static-1.12033",
      "data-model-commons-lib": "/data-model-commons-lib/static-1.12046",
      "feedback-loader": "/feedback-loader/static-1.28938",
      "final-form": "/final-form/static-1.66",
      "html-to-image": "/html-to-image/static-1.50",
      "object-definition-builder-lib": "/object-definition-builder-lib/static-1.6906",
      "property-management-iframe": "/property-management-iframe/static-1.12486",
      "property-usages-lib": "/property-usages-lib/static-1.5234",
      "reactflow": "/reactflow/static-1.60",
      "simple-data-table": "/simple-data-table/static-1.2285",
      "used-in-list-lib": "/used-in-list-lib/static-1.6761",
      "visual-association": "/visual-association/static-1.5689",
      "highcharts": "/highcharts/static-8.100",
      "reporting-visualizations": "/reporting-visualizations/static-1.58749",
      "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3781",
      "automation-platform-service-types": "/automation-platform-service-types/static-1.2522",
      "ContentData": "/ContentData/static-1.67806",
      "email-portal-health-service-types": "/email-portal-health-service-types/static-1.813",
      "marketing-email-service-types": "/marketing-email-service-types/static-1.1790",
      "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.81",
      "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.251",
      "content-whatsapp-service-types": "/content-whatsapp-service-types/static-1.272",
      "marketing-platform-lib": "/marketing-platform-lib/static-1.6679",
      "short-messages-app-service-client": "/short-messages-app-service-client/static-1.3849",
      "ui-tool-access": "/ui-tool-access/static-1.9981",
      "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1420",
      "user-context-client": "/user-context-client/static-1.4477",
      "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35132",
      "sales-views-client-types": "/sales-views-client-types/static-1.4123",
      "trellis-story-utils": "/trellis-story-utils/static-1.4357",
      "hub-http-contrib": "/hub-http-contrib/static-1.2880",
      "interframe": "/interframe/static-3.4617",
      "tinymce-data": "/tinymce-data/static-1.39932",
      "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5051",
      "codemirror": "/codemirror/static-5.91",
      "layout-dnd-components": "/layout-dnd-components/static-1.12106",
      "layout-dnd-utils": "/layout-dnd-utils/static-1.11081",
      "react-codemirror": "/react-codemirror/static-1.10463",
      "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.14136",
      "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8932",
      "hls.js": "/hls.js/static-1.35",
      "js-cookie": "/js-cookie/static-1.18",
      "ai-rendering-library": "/ai-rendering-library/static-1.9417",
      "ai-settings-ui-library": "/ai-settings-ui-library/static-1.7558",
      "copilot-plugins": "/copilot-plugins/static-1.10600",
      "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.3018",
      "products-ui-components": "/products-ui-components/static-1.39477",
      "quotes-ui-lib": "/quotes-ui-lib/static-1.80046",
      "zustand": "/zustand/static-1.51",
      "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.6784",
      "invoices-ui-lib": "/invoices-ui-lib/static-1.54165",
      "commerce-products-api": "/commerce-products-api/static-1.2007",
      "SafeStorage": "/SafeStorage/static-1.4240",
      "invoices-iframe-lib": "/invoices-iframe-lib/static-1.56223",
      "quotes-modal-lib": "/quotes-modal-lib/static-1.102003",
      "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7527",
      "reporting-ui-components": "/reporting-ui-components/static-2.63944",
      "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14627",
      "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.56",
      "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.17585",
      "stripe-embedded-components": "/stripe-embedded-components/static-1.7198",
      "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9382",
      "association-translator": "/association-translator/static-1.3024",
      "crm-settings-header-lib": "/crm-settings-header-lib/static-1.8154",
      "settings-ui-nav": "/settings-ui-nav/static-2.10020",
      "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.20474",
      "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.2027",
      "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5709",
      "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4091",
      "property-management-common": "/property-management-common/static-1.4773",
      "d3": "/d3/static-1.7",
      "advanced-menus-core": "/advanced-menus-core/static-1.14872",
      "advanced-menus-lib": "/advanced-menus-lib/static-1.11842",
      "ExportDialog": "/ExportDialog/static-6.10224",
      "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33550",
      "diff-match-patch": "/diff-match-patch/static-1.7",
      "layout-data-lib": "/layout-data-lib/static-1.9406",
      "browser-eslint": "/browser-eslint/static-2.57",
      "embedded-academy-lib": "/embedded-academy-lib/static-1.13682",
      "highlight.js": "/highlight.js/static-1.75",
      "reporting-action-components": "/reporting-action-components/static-1.40750",
      "reporting-snowflake": "/reporting-snowflake/static-1.55291",
      "commerce-tax-lib": "/commerce-tax-lib/static-1.353",
      "property-description-translator": "/property-description-translator/static-1.3692",
      "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3492",
      "totals-ui-components": "/totals-ui-components/static-1.23089",
      "reporting-plugins": "/reporting-plugins/static-1.10022",
      "reporting-reports": "/reporting-reports/static-1.66351",
      "edison-service-client-types": "/edison-service-client-types/static-1.229",
      "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10330",
      "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.16459",
      "marketplace-ui-common": "/marketplace-ui-common/static-1.19052",
      "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.7829",
      "stripe-connect-js": "/stripe-connect-js/static-1.65",
      "seamless-immutable": "/seamless-immutable/static-7.6",
      "simple-menus-core": "/simple-menus-core/static-1.14871",
      "simple-menus-lib": "/simple-menus-lib/static-1.16388",
      "academy-common-lib": "/academy-common-lib/static-1.13142",
      "dashboard-lib": "/dashboard-lib/static-1.80777",
      "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8530",
      "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3676",
      "campaign-roi-lib": "/campaign-roi-lib/static-1.8396",
      "apps-service-types": "/apps-service-types/static-1.3714",
      "oauth-service-types": "/oauth-service-types/static-1.4084",
      "react-window": "/react-window/static-1.13",
      "academy-service-client": "/academy-service-client/static-1.3518",
      "redux-actions": "/redux-actions/static-3.7"
    },
    "bundlingPackage": "conversations-visitor-ui",
    "bundlingPackageVersion": "static-1.28445",
    "project": "conversations-visitor-ui",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};